import type { ReactNode } from 'react'

import styled from 'styled-components'

const Title = styled.h2<{ version: string }>`
  font-size: 0.875rem;
  line-height: 1.5;
  width: ${({ version }) => (version === 'new' ? 'auto' : '9rem')};

  & .text-box {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    font-size: inherit;
    line-height: inherit;
  }
`

type CollapseTitleProps = {
  children: ReactNode
  version: string
}

export const CollapseTitle = ({ children, version }: CollapseTitleProps) => (
  <Title
    version={version}
    className='_mb-0 _align-self-center _flex-grow-1 _text-gray-900 _font-weight-bold'>
    <span className='text-box'>{children}</span>
  </Title>
)
